var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgAdFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0504 9.7563H5.94958C5.28127 9.7563 4.7395 10.2981 4.7395 10.9664V12.9832C4.7395 13.6515 5.28127 14.1933 5.94958 14.1933H18.0504C18.7187 14.1933 19.2605 13.6515 19.2605 12.9832V10.9664C19.2605 10.2981 18.7187 9.7563 18.0504 9.7563Z",
    fill: "var(--primary-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24H21C22.6569 24 24 22.6569 24 21V3C24 1.34315 22.6569 0 21 0H3ZM2 3.90756C2 3.40633 2.40633 3 2.90756 3H21.0924C21.5937 3 22 3.40633 22 3.90756C22 4.4088 21.5937 4.81513 21.0924 4.81513H2.90756C2.40633 4.81513 2 4.4088 2 3.90756ZM2 20.0924C2 19.5912 2.40633 19.1849 2.90756 19.1849H21.0924C21.5937 19.1849 22 19.5912 22 20.0924C22 20.5937 21.5937 21 21.0924 21H2.90756C2.40633 21 2 20.5937 2 20.0924ZM5.94958 7.94118C4.2788 7.94118 2.92437 9.29561 2.92437 10.9664V12.9832C2.92437 14.654 4.2788 16.0084 5.94958 16.0084H18.0504C19.7212 16.0084 21.0756 14.654 21.0756 12.9832V10.9664C21.0756 9.29561 19.7212 7.94118 18.0504 7.94118H5.94958Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdFilled);
export default __webpack_public_path__ + "static/media/adFilled.54a184bae25de3afa9349da50595594d.svg";
export { ForwardRef as ReactComponent };